import React, { Suspense } from "react";
import "./App.css";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import NavBar from "./components/navbar/NavBar";

function App() {
  const HomePage = React.lazy(() => import("./components/home/Home"));
  const ResumePage = React.lazy(() => import("./components/resume/Resume"));

  return (
    <Box>
      <NavBar />
      <Suspense
        fallback={
          <Flex
            direction="column"
            h="100vh"
            w="full"
            justifyContent="center"
            alignItems="center"
          >
            <Spinner />
          </Flex>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="resume"
            element={
              <ResumePage pdfUrl="https://firebasestorage.googleapis.com/v0/b/my-resume-2ce6f.appspot.com/o/CV%20Lereko%20Foloko%20Updated%202023.pdf?alt=media&token=5dc0c48d-b753-4ca0-8416-8315ee4fbb37" />
            }
          />
        </Routes>
      </Suspense>
    </Box>
  );
}

export default App;
